import React from 'react'
import PropTypes from 'prop-types'
import { connect } from 'react-redux'
import ReactLoading from 'react-loading'

import BaseComponent from 'utils/BaseComponent'
import request from 'utils/request'

import Button from 'components/Button'

import NewNotification from './NewNotification'
import NotificationList from './NotificationList'

import { CLAIM_UPDATES } from 'constants'

import { notificationFetched } from './actions'

import './styles.scss'

export class Notifications extends BaseComponent {

  constructor() {
    super()


    this._bind('_renderNotifications', '_showModal', '_getNotifications')
  }

  componentDidMount() {
    this._getNotifications()
  }

  _getNotifications() {
    request(CLAIM_UPDATES(this.props.claimId))
      .then(({updates}) => {
        this.props.notificationFetched(updates)
      }).catch((err) => {console.log(err)})
  }

  _renderNotifications() {
    if(this.props.notification_list.length === undefined) {
      return (
        <ReactLoading id="Spin" type={'spin'} color={'#444'}  />
      )
    } else {
      return !!this.props.notification_list.length ? (
        <NotificationList claimId={this.props.claimId} notifications={this.props.notification_list}/>
      ) : (<p className="message">No hay ninguna notificación aún</p>)
    }
  }

  _showModal() {
    this.context.toggleModal(true,
      <NewNotification claimId={this.props.claimId} claim={this.props.claim}/>
    )
  }

  render() {
    return (
      <div className="SinisterNotifications">
        <div className="SinisterNotifications__head d-flex align-items-center">
          <h1>Notificaciones</h1>
          <Button className="justify-content-center" onClick={this._showModal} buttonType="primary" size="label">
            <i className="material-icons">add</i>
            Crear nueva
          </Button>
        </div>
        <div className="SinisterNotifications__list">
          {this._renderNotifications()}
        </div>
      </div>
    )
  }
}


Notifications.contextTypes = {
  toggleModal: PropTypes.func.isRequired,
}


const mapStateToProps = (state) => {
  return {
    notification_list: state.claimNotification.get('notification_list')
  }
}

const mapDispatchToProps = (dispatch, ownProps) => {
  return {
    notificationFetched: (notification_list) => dispatch(notificationFetched(notification_list))
  }
}


export default connect(mapStateToProps, mapDispatchToProps)(Notifications)



// WEBPACK FOOTER //
// ./src/scenes/VehicleDetail/components/Claim/Notifications/index.js